module.exports = [{"value":""},{"value":"dove@petronas.com"}]


//////////////////
// WEBPACK FOOTER
// ./src/Controls/Select/DataCompanyEmailPETCO.json
// module id = 7640
// module chunks = 21